var Curriculog = Curriculog || {};

Curriculog.DateFromFilter = (function ($, _, Backbone, DateFromFilter) {
	
	DateFromFilter = Backbone.View.extend({

		el: function () {
			return $('#report-9-from');
		},

		// el: '#report-9-from',

		events: {},

		initialize: function(options) {
			this.params = options.params;
		},

		get: function(date) {
			// Empty "from" date should resolve to empty string on UI
			if (date === '01/01/0001') {
				date = '';
			}

			this.$el.val(date);
			this.$el.datepicker();
		},

		set: function() {
			return this.$el.val();
		},

	});

	return DateFromFilter;

})($, _, Backbone, Curriculog.DateFromFilter || {});